import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

const version = 'v1';

const endpointTiposProdutos = `/${version}/tipos-produtos`;

export function useTiposProdutosService() {
  const { backendGet } = Sebrae.useBackend();

  const getAtivos = React.useCallback(
    () => backendGet(`${endpointTiposProdutos}/ativos`),
    [backendGet],
  );

  return {
    getAtivos,
  };
}
